import { getFirstTwoLetters } from '~/shared/lib/getFirstTwoLetters';
import { Typography } from '~/shared/ui/Typography/Typography';

import { type Certificate } from '../../PayPage.scheme';
import { CERTIFICATES_CONFIG } from '../steps/SelectCertificateStep/constants/certificates';

import { IconName, Name, Root, IconImage } from './CertificateCard.ui';

export const CertificateCard = ({
  certificate,
  onClick,
  showName = true,
  classNames,
}: {
  certificate: Certificate;
  onClick?: (certificate: Certificate) => void;
  showName?: boolean;
  classNames?: {
    button?: string;
    image?: string;
  };
}) => {
  const { brand: { title, slug } = {} } = certificate || {};

  const config = CERTIFICATES_CONFIG[slug || ''];

  return (
    <Root
      {...(onClick && { onClick: () => onClick(certificate) })}
      type="button"
      className={classNames?.button}
      tabIndex={onClick ? 0 : -1}
      disabled={!onClick}
    >
      {config?.iconUrl ? (
        <IconImage
          className={classNames?.image}
          src={config.iconUrl}
          alt={title}
          loading="lazy"
        />
      ) : (
        <IconName>
          <Typography.H1>
            {getFirstTwoLetters(title || '').toUpperCase()}
          </Typography.H1>
        </IconName>
      )}
      {showName && title && <Name>{title}</Name>}
    </Root>
  );
};
